export enum AccessAccountStatus {
  Pending = 'pending',
  Finished = 'finished',
}
